import { Utilities as utilities } from '@truckdown/framework';
import { Point } from './Point';

export class City {
    constructor(json?: any) {
        if (json) {
            this.id = utilities.json.getStringValue(json, 'id', '');
            this.regionCode = utilities.json.getStringValue(json, 'rd', '');
            this.countryCode = utilities.json.getStringValue(json, 'cntry', '');
            this.name = utilities.json.getStringValue(json, 'n', '');
            this.suppressSeo = utilities.json.getBooleanValue(json, 'seo', false);
            this.point = utilities.json.getObjectValue<Point>(json, (data) => {
                return data as Point;
            }, 'po', { lat: 0, lng: 0 });
        }
    }

    id: string = '';
    regionCode: string = '';
    countryCode: string = '';
    name: string = '';
    point: Point = { lat: 0, lng: 0 };
    suppressSeo: boolean = false;
}